import { useEntryGroupsCache, useMattersCache } from "@/shared/cache";
import type { Entry } from "./normalize";

/**
 * Thin adapter around the entry-group cache so the view keeps its existing
 * `{ data, isLoading }` contract.
 */
export function useAllEntries(
	timekeeperId?: string | null,
	enabled = true,
): {
	data: Entry[];
	isLoading: boolean;
} {
	// Billability comes from matters, not the entry-group response. Supply the
	// same catalog as EntriesView, including when entries are already cached.
	const { matters, isLoading: mattersLoading } = useMattersCache();
	const { entries, isLoading } = useEntryGroupsCache(
		matters,
		enabled && !mattersLoading,
		{ timekeeperId },
	);
	return { data: entries, isLoading: !enabled || mattersLoading || isLoading };
}
